import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './list-section.css';

/**
 * @property {string} title
 * @property {array} list
 */
export default class ListSection extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    properties() {
        return {
            title: '',
        };
    }

    template() {
        return html`
            <div class="text-lg text-green-medium font-medium mb-24">${this.title}</div>
            <div class="list flex flex-col gap-24 md:gap-0">
                <slot></slot>
            </div>
        `;
    }
}

defineElement('mb-list-section', ListSection);
